import Cookies from 'js-cookie/src/js.cookie'

jQuery(document).ready(function($) {

	$.cookiehint = {
		init: function() {

			/*cookie disclaimer*/
			var cookie = Cookies.get('cookie_accept');
			if (!cookie) {
				var iCookieHeight = $("#m-cookie").outerHeight(true);
				$('#footer').animate({
					marginTop: '+=' + iCookieHeight + 'px'
				}, {duration: "slow", queue: false});

				$("#m-cookie").show().animate({
					top: '+=300px'
				}, {duration: "slow", queue: false});

				$('#m-cookie .m-cookie__close').click(function() {
					$('#footer').animate({
						marginTop: '-=' + iCookieHeight + 'px'
					}, {
						duration: "slow", queue: false, complete: function() {
							$('#footer').css('margin-bottom', '0');
						}
					});

					$("#m-cookie").animate({
						top: '-=300px'
					}, {
						duration: "slow", queue: false, complete: function() {
							$("#m-cookie").hide();
						}
					});

					Cookies.set('cookie_accept', '1', {
						expires: 365,
						path   : '/'
					});

					return false;
				});
			}
			
		},
	
	};

});